import type { BenchmarkCostTier } from '../../../shared/domain/contribution-model'
import type {
  PolicyCostSummaryDto,
  PolicyCostSummaryTierTotalsDto,
} from '../../infra/api/policy-total-cost.dto'
import type { PolicyTotalCostVM } from './policy-total-cost.vm'

function pickTierTotals(
  response: PolicyCostSummaryDto,
  tier: BenchmarkCostTier
): PolicyCostSummaryTierTotalsDto {
  return response[tier]
}

export function mapCostSummaryToPolicyTotalCostViewModel(
  response: PolicyCostSummaryDto,
  tier: BenchmarkCostTier
): PolicyTotalCostVM {
  const totals = pickTierTotals(response, tier)

  return {
    tier,
    monthly: {
      total: totals.totalMonthlyCost,
      employer: totals.employerMonthlyCost,
      employee: totals.employeeMonthlyCost,
    },
    yearly: {
      total: totals.totalYearlyCost,
      employer: totals.employerYearlyCost,
      employee: totals.employeeYearlyCost,
    },
  }
}
